export default "__VITE_ASSET__2da9c83a__"